import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
} from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { WorkflowDisplayPdfFrameService } from "../../../core/services/workflow-display-pdf-frame.service";
import { EmailTemplates } from "../../../core/models/orders/emailTemplates";
import { WorkflowEmailData } from "../../../core/models/project-workflow/workflowEmailData";
import { LoaderService } from "../../../core/services/loader.service";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { EnumWorkflowEmailState } from "../../../shared/enums/workflowEmailState";
import { CommonModule } from "@angular/common";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-workflow-display-pdf-frame",
  templateUrl: "./workflow-display-pdf-frame.component.html",
  styleUrls: ["./workflow-display-pdf-frame.component.scss"],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    NgxExtendedPdfViewerModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class WorkflowDisplayPdfFrameComponent implements OnInit, OnChanges {
  @Input() displayRushRevisedSection = true;
  @Input() parent!: FormGroup;
  @Input() set templatesList(emailTemplates: EmailTemplates[]) {
    this.templates = emailTemplates;
    this.parent.patchValue({
      header: {
        templateId: this.templates[0]?.id,
      },
    });
  }
  @Input() poNumberRevision: string[] = [];
  @Output() emailSelectionEvent = new EventEmitter();
  @Input() workflowEmailData: WorkflowEmailData = {} as WorkflowEmailData;
  @Output() base64Pdf = new EventEmitter();
  templates: EmailTemplates[] = [];
  workflowJournalPdf = "";
  workflowId = 0;
  windowState = 0;
  saleOrderId = "";
  displayWorkflowSection = true;
  displaySaleOrderSection = false;
  @Input() isAnyUnCommitLines = false;
  @Output() refreshOrderLinesGrid = new EventEmitter();
  @Input() salesOrderId = "";
  @Output() downloadProjectSummaryExcelEvent = new EventEmitter();

  constructor(
    private _loaderService: LoaderService,
    private _activatedRoute: ActivatedRoute,
    private _displayPdfFrameService: WorkflowDisplayPdfFrameService,
    private _productionWorkflowService: ProjectWorkflowService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.workflowId = params["poNumber"];
      this.windowState = params["windowState"] ?? 0;
      this.saleOrderId = params["id"];
    });
  }

  ngOnInit(): void {
    this.disabledWorkflowNumber();
    this.getEmailWorkflow();
    this.patchValueInPO();
    this.patchValueInSaleOrder();
    this.disabledSaleOrder();

    if (this.windowState == EnumWorkflowEmailState.PrintWorkflowSummary) {
      this.displayWorkflowSection = false;
      this.displaySaleOrderSection = true;
    }
  }

  ngOnChanges(): void {
    if (this.workflowEmailData?.windowState) {
      this.saleOrderId = this.workflowEmailData.saleOrderId;
      this.workflowId = this.workflowEmailData.workflowId;
      this.windowState = this.workflowEmailData.windowState;
    }
  }

  onEmailSelection() {
    this.emailSelectionEvent.emit();
  }

  disabledWorkflowNumber() {
    this.parent.get(["header", "workflowId"])?.disable();
  }
  disabledSaleOrder() {
    this.parent.get(["header", "saleOrderId"])?.disable();
  }

  patchValueInPO() {
    this.parent.patchValue({
      header: {
        workflowId: this.workflowId,
      },
    });
  }

  patchValueInSaleOrder() {
    this.parent.patchValue({
      header: {
        saleOrderId: this.saleOrderId,
      },
    });
  }

  getEmailWorkflow() {
    this._loaderService.setLoaderState(true);

    if (this.windowState == EnumWorkflowEmailState.PrintWorkflowSummary) {
      this._productionWorkflowService
        .getProjectWorkflowSummaryDocument(this.saleOrderId, this.workflowId)
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() == "success") {
              this.workflowJournalPdf = res.data;
              this.base64Pdf.emit(this.workflowJournalPdf);
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  projectSummaryExcelDownload() {
    this.downloadProjectSummaryExcelEvent.emit();
  }
}
